
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAdminIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationUUID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminPossibleIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgUUID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationUUID"}}},{"kind":"Argument","name":{"kind":"Name","value":"providerKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerKey"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminIntegration"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iconURL"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"providerKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isACIIntegrated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productLongDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productShortDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adminCustomizedIntegrationSetup"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"redirectURI"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"redirectURIMask"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"installationURLDomain"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"integrationOauthConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scopes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"authUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tokenUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":629}};
    doc.loc.source = {"body":"query GetAdminIntegration($organizationUUID: String!, $providerKey: String!) {\n  adminPossibleIntegration(orgUUID: $organizationUUID, providerKey: $providerKey) {\n    __typename\n    ... on AdminIntegration {\n      title\n      iconURL\n      providerKey\n      isACIIntegrated\n      productLongDescription\n      productShortDescription\n      adminCustomizedIntegrationSetup {\n        integrationKey\n        redirectURI\n        redirectURIMask\n        installationURLDomain\n        integrationOauthConfig {\n          scopes\n          authUrl\n          clientId\n          tokenUrl\n          clientSecret\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["GetAdminIntegration"] = oneQuery(doc, "GetAdminIntegration");
        
